/* eslint-disable no-unused-vars */
import * as React from 'react';
import Link from 'next/link';
import Box from '@mui/material/Box';
import { Button, Grid, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { tokens } from '../../../tokens';

function Copyright() {
  return (
    <>
      {' © '}
      <Link href="./about/blockquiry">
        <Button size="small" sx={{ textTransform: 'none', bgcolor: 'none' }}>
          blockquiry {new Date().getFullYear()}.
        </Button>
      </Link>{' '}
    </>
  );
}

const Item = styled(Box)(() => ({
  px: 2,
  color: tokens.token_typography_regular,
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.775rem',
  fontWeight: 500,
  whiteSpace: 'nowrap',
}));

const StyledLink = styled(Link)(() => ({
  // px: 2,
  color: tokens.token_typography_regular,
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.775rem',
  fontWeight: 500,
  whiteSpace: 'nowrap',
}));

export default function Footer() {
  return (
    <Box
      component="footer"
      position="fixed"
      bottom={0}
      width="100%"
      sx={{ backgroundColor: tokens.token_grey_100 }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        px={5}
        py={0.25}
      >
        <Grid item xs={12} sm={4}>
          <Grid
            container
            justifyContent={{ xs: 'center', sm: 'center', md: 'flex-start' }}
            spacing={1}
            sx={{ display: { xs: 'none', md: 'flex' } }}
          >
            <Grid item>
              <Link href="/web/blockquiry/searx">
                <Button
                  size="small"
                  sx={{ textTransform: 'none', bgcolor: 'none' }}
                >
                  web
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link href="/tor/blockquiry">
                <Button
                  size="small"
                  sx={{ textTransform: 'none', bgcolor: 'none' }}
                >
                  tor
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box textAlign={{ xs: 'center', sm: 'center', md: 'center' }}>
            <Copyright />
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Grid
            container
            justifyContent={{ xs: 'center', sm: 'center', md: 'flex-end' }}
            spacing={1}
            sx={{ display: { xs: 'none', md: 'flex' } }}
          >
            <Grid item>
              <Link href="/about/blockquiry/privacy">
                <Button
                  size="small"
                  sx={{ textTransform: 'none', bgcolor: 'none' }}
                >
                  Privacy
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link href="/about/blockquiry/terms">
                <Button
                  size="small"
                  sx={{ textTransform: 'none', bgcolor: 'none' }}
                >
                  Terms
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
